export const isOnboardingDestinationReady = (
	currentPathname: string,
	destinationPathname: string,
) => currentPathname === destinationPathname
